import React from 'react';
import If from './If';
import LoadingMessage from './LoadingMessage';
import { Alert, Progress } from 'reactstrap';

const VideoLoadingIndicator = ({ isFrameCacheReady, cacheProgress, previewVideoLoadedBytes, previewVideoTotalBytes, loadingPerc, downloadedMb }) => (
  <If condition={!isFrameCacheReady}>
    <Alert color="secondary">
      <If condition={!cacheProgress || previewVideoLoadedBytes < previewVideoTotalBytes}>
        <LoadingMessage>Downloading ({downloadedMb}MB)</LoadingMessage>
      </If>
      <If condition={cacheProgress}>
        <LoadingMessage>Preparing Preview</LoadingMessage>
      </If>
      <Progress animated value={loadingPerc} className="mt-2" />
    </Alert>
  </If>
)

export default VideoLoadingIndicator;



// WEBPACK FOOTER //
// ./src/components/VideoLoadingIndicator.js